import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import About from "../pages/about/About";
import Gallery from "../pages/gallery/Gallery";
import Plans from "../pages/plans/Plans";
import Contacts from "../pages/contacts/Contacts";
import Profile from "../pages/profile/profile";
import TraineeProfile from "../pages/profile/traineeprofile";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Trainers from "../pages/trainers/Trainers";
import NotFound from "../pages/notFound/NotFound";
import Challenges from "../pages/challenges/challenges";
import SingleChallenge from "../pages/challenges/singleChallenge";

const Client = () => {
    return(
        <>
            <Navbar />
            <Routes>
                <Route index element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/trainers" element={<Trainers />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/profile/:ID/trainer" element={<Profile />} />
                <Route path="/challenges" element={<Challenges />} />
                <Route path="/challenges/challenge/:ID" element={<SingleChallenge />} />
                <Route path="/trainee/:ID/profile/:TYPE" element={<TraineeProfile />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
        </>
    );
}

export default Client;